module.exports = __webpack_public_path__ + "img/4_2_m.22beea01.jpg";